module.exports = __webpack_public_path__ + "images/icons/psp/portable-storage/loading-time.svg";